export const COMPOSE_FORM_HANDLE_CHANGE = 'COMPOSE_FORM_HANDLE_CHANGE'
export const COMPOSE_FORM_CLEAR = 'COMPOSE_FORM_CLEAR'
